import apiClient from '../middleware/apiClient';
import { SSM_NOW_UPDATE_PAYMENT } from '../helpers/apis';
import { COTTON_SSM_NOW_UPDATE_PAYMENT } from '../helpers/cottonApis';
import { isCottonSession as getCottonSession } from '../helpers/featureFlags/cotton';


export const NOW_UPDATE_PAYMENT_LOADING = 'NOW_UPDATE_PAYMENT_LOADING';
export const NOW_UPDATE_PAYMENT_SUCCESS = 'NOW_UPDATE_PAYMENT_SUCCESS';
export const NOW_UPDATE_PAYMENT_FAILURE = 'NOW_UPDATE_PAYMENT_FAILURE';

function dispatchNowUpdatePayment(data, isCottonSession = false) {
  const endpoint = isCottonSession ? COTTON_SSM_NOW_UPDATE_PAYMENT : SSM_NOW_UPDATE_PAYMENT;
  return {
    type: NOW_UPDATE_PAYMENT_LOADING,
    payload: apiClient.fetch(endpoint, { method: 'PUT', body: JSON.stringify(data) }),
  };
}

function dispatchNowUpdatePaymentSuccess() {
  return {
    type: NOW_UPDATE_PAYMENT_SUCCESS,
  };
}

function dispatchNowUpdatPaymentError() {
  return {
    type: NOW_UPDATE_PAYMENT_FAILURE,
  };
}

/**
 * Dispatches NOW_UPDATE_PAYMENT_* actions
 *
 * @param {Object} data
 * @param {string} data.product - NowInternet | NowMobile | NowTV
 * @param {string} data.token - payment instrument token
 */
export const updatePaymentMethod = data => async (dispatch) => {
  const isCottonSession = getCottonSession();
  try {
    const response = await dispatch(dispatchNowUpdatePayment(data, isCottonSession)).payload;
    dispatch(dispatchNowUpdatePaymentSuccess(response));
  } catch {
    dispatch(dispatchNowUpdatPaymentError());
  }
};
